/**
 * Created by stephen on 4/20/17.
 */
import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';

import ajaxCallsInProgress from './ajaxCallsInProgressReducer'

const rootReducer = combineReducers({
    // simulations, // NOT ES6 short-hand property name
    // projects, // this impacts state in the rest of the application
    // authors, // this impacts state in the rest of the application
    // grids, // this impacts state in the rest of the application
    ajaxCallsInProgress,
    routing: routerReducer
});

export default rootReducer;




// WEBPACK FOOTER //
// ./src/reducers/index.js